export enum ADVENTURE_CHARACTER {
    meticulousGeek = 'meticulous-geek',
    analyticalPhilosopher = 'analytical-philosopher',
    committedJournalist = 'committed-journalist',
    busyInvestor = 'busy-investor',
    restlessMinor = 'restless-minor',
}
